"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _reactRouterDom = require("react-router-dom");
var _ApplicationContext = require("../api/ApplicationContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const OAuthLaunch = () => {
  const searchParams = new URLSearchParams(window.location.search);
  let scope = searchParams.get('scope');
  let state = searchParams.get('state');
  let clientId = searchParams.get('client_id');
  let redirectUri = searchParams.get('redirect_uri');
  state = _dompurify.default.sanitize(state || '');
  scope = _dompurify.default.sanitize(scope || '');
  clientId = _dompurify.default.sanitize(clientId || '');
  redirectUri = _dompurify.default.sanitize(redirectUri || '');
  _ApplicationContext.ApplicationContext.setContext('oauth.client.id', clientId);
  _ApplicationContext.ApplicationContext.setContext('oauth.scope', scope);
  _ApplicationContext.ApplicationContext.setContext('oauth.state', state);
  _ApplicationContext.ApplicationContext.setContext('oauth.redirect.uri', redirectUri);
  (0, _react.useEffect)(() => {
    const loginPath = _ApplicationContext.ApplicationContext.getLoginPath();
    if (loginPath && loginPath !== '') {
      window.location.href = loginPath;
    }
  }, [_ApplicationContext.ApplicationContext.getLoginPath()]);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(OAuthLaunch);
//# sourceMappingURL=OAuthLaunch.js.map